import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="inline-flex items-center gap-2 cursor-pointer mb-4">
                <span className="text-2xl font-heading text-primary-500 whitespace-nowrap">韩漫</span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">漫画网</span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                韩漫漫画网站 - 海量正版漫画在线阅读平台，提供免费的韩国漫画大全，让每一次阅读都建立在正规资源之上。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">分类浏览</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">热门分类</h4>
              <ul className="space-y-2">
                <li><Link to="/category/romance" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">浪漫爱情</Link></li>
                <li><Link to="/category/fantasy" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">奇幻冒险</Link></li>
                <li><Link to="/category/action" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">热血动作</Link></li>
                <li><Link to="/category/comedy" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">搞笑日常</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系我们</h4>
              <ul className="space-y-2 text-sm text-foreground-500">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>support@manhwa-reader.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-customer-service-line text-primary-400"></i>
                  <span>在线客服 9:00-21:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 韩漫漫画网站 版权所有 | 本站所有漫画资源均来自正版授权
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}